/**
 * Action types for NetPulse Redux
 */
export const SET_NET_PULSE_DATA = "SET_NET_PULSE_DATA";
export const SET_NET_PULSE_LOADING = "SET_NET_PULSE_LOADING";
export const DATA_FETCH_INIT = "DATA_FETCH_INIT";
export const SET_ORGANIZATIONS_LOADING = "SET_ORGANIZATIONS_LOADING";
export const SET_DEVICES_LOADING = "SET_DEVICES_LOADING";
